export interface Sede {
  city: string;
  venue: string;
  shortDescription: string;
  // Opcionales — sólo poblados cuando los datos vienen del CMS, no del
  // dataset estático de fallback. Se renderizan condicionalmente.
  imageUrl?: string;
  mapUrl?: string;
}

export const sedes: Sede[] = [
  {
    city: "Badajoz",
    venue: "Fundación Universidad-Sociedad",
    shortDescription: "Sede central. Coordinación general y campamentos urbanos.",
  },
  {
    city: "Cáceres",
    venue: "Escuela Politécnica",
    shortDescription: "Talleres tecnológicos y campamentos urbanos.",
  },
  {
    city: "Mérida",
    venue: "Centro Universitario de Mérida",
    shortDescription: "Campamentos urbanos y actividades anuales.",
  },
  {
    city: "Plasencia",
    venue: "Centro Universitario de Plasencia",
    shortDescription: "Campamentos urbanos y actividades anuales.",
  },
];
